import { Instagram, Youtube } from "lucide-react";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 1 0 15.67 15.67V8.75a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.18z" />
  </svg>
);

const socials = [
  {
    name: "Instagram",
    url: "https://instagram.com/kitoe.ent",
    Icon: Instagram,
    hover: "hover:bg-[#E1306C] hover:text-white hover:border-ink",
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@kitoe.ent",
    Icon: TikTokIcon,
    hover: "hover:bg-ink hover:text-cream hover:border-ink",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@KITOE-ent",
    Icon: Youtube,
    hover: "hover:bg-[#FF0000] hover:text-white hover:border-ink",
  },
];

export const SocialLinks = ({ dark = false, size = "md" }) => {
  const box = size === "lg" ? "w-14 h-14" : "w-11 h-11";
  const icon = size === "lg" ? 22 : 18;
  const base = dark
    ? "bg-cream/10 border-cream/25 text-cream"
    : "bg-white border-ink text-ink";
  return (
    <div className="flex gap-3" data-testid="social-links">
      {socials.map(({ name, url, Icon, hover }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-${name.toLowerCase()}-link`}
          aria-label={`KITOE entertainment on ${name}`}
          className={`${box} ${base} ${hover} rounded-2xl border-2 flex items-center justify-center hover:-translate-y-1 hover:shadow-brutal-sm transition-all duration-200`}
        >
          <Icon size={icon} />
        </a>
      ))}
    </div>
  );
};
